/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const o = {
  button: "k-button",
  flat: "k-flat",
  outline: "k-outline",
  clear: "k-button-clear",
  primary: "k-primary",
  "state-selected": "k-selected",
  "button-icon": "k-button-icon",
  "button-icontext": "k-button-icontext",
  "state-disabled": "k-disabled",
  "group-start": "k-group-start",
  "group-end": "k-group-end",
  "button-group": "k-button-group",
  "button-group-stretched": "k-button-group-stretched",
  ltr: "k-ltr",
  rtl: "k-rtl"
}, t = ":not(.k-dropdownlist button):not(.k-colorpicker button):not(.k-split-button .k-split-button-arrow)", n = [
  "button" + t,
  ".k-button-group > button" + t,
  ".k-colorpicker",
  ".k-dropdownlist"
];
export {
  o as styles,
  n as toolbarButtons
};
